import {MetricsSection} from '/constant/TestIDs';
import {
  REPORT_EARNED_ACCELERATOR_BONUS,
  REPORT_EARNED_CAB,
  REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_ELIGIBLE_ACCELERATOR_BONUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
  REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
  REPORT_ELIGIBLE_FOR_CAB,
  REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP,
  REPORT_ELIGIBLE_FOR_QSB,
  REPORT_RANK_UP,
} from '/enum/records.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {FEATURE_FLAGS} from '/DevFeatureFlags';

export const useBonusesSection = ({
  clientAcquisitionBonus,
  eligibleForAccelBonusCount,
  onShowReport,
  quickStartBonus,
  onShowInfoPopover,
  oneToTwoCSBPClientCount,
  threeToFourCSBPClientCount,
  sevenToNineCSBPClientCount,
  eligibleClientSupportBonusPlusCount,
  showCsbPlusInsightsFiltering,
  NewCoachesAquiringClients,
  fiveToSixCSBPClientCount,
  showIncentiveTrip,
  eligibleForIncentiveTrip,
  showEligibleQSB,
  showEnhancedCSBPlus,
  showCSBPlus,
  rankUp,
  earnedClientSupportBonusPlusCount,
  earnedAccelBonusCount,
}: any) => {
  const {tt, ts} = useTranslation('screen.teams.section.bonusesSection');
  let listItems = [];
  if (showIncentiveTrip) {
    listItems.push({
      label: tt('eligibleIncentiveTrip', 'Eligible for Incentive Trip 2024'),
      value: eligibleForIncentiveTrip,
      recordsName: REPORT_ELIGIBLE_FOR_INCENTIVE_TRIP,
      testID: MetricsSection.metricEligibleForIncentiveTrip,
    });
  }

  if (FEATURE_FLAGS.showCabBonus) {
    listItems.push({
      label: tt('clientAcquisition', 'Eligible for Client Acquisition Bonus'),
      value: clientAcquisitionBonus,
      recordsName: REPORT_ELIGIBLE_FOR_CAB,
      testID: MetricsSection.metricEligibleForCAB,
    });
  }

  if (showEnhancedCSBPlus) {
    listItems.push({
      label: tt('clientSupport', 'Eligible for Client Support Bonus+'),
      value: eligibleClientSupportBonusPlusCount,
      recordsName: REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
      testID: MetricsSection.metricEligibleForCSBP,
      screenName: REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
    });
  }
  if (showCsbPlusInsightsFiltering) {
    listItems.push({
      label: tt('qualifiedforCSB+', 'CSB+ (1-2 New Clients)'),
      value: oneToTwoCSBPClientCount,
      testID: MetricsSection.metricQualifiedForCSBP_One_Two,
      recordsName: REPORT_ELIGIBLE_CLIENT_SUPPORT_ONE_TWO,
      screenName: 'csb+_1_2_new_clients',
    });
    listItems.push({
      label: tt('clientAchievedSupportTier1', 'CSB+ (3-4 New Clients)'),
      value: threeToFourCSBPClientCount,
      testID: MetricsSection.metricQualifiedForCSBP_Three_Four,
      recordsName: REPORT_ELIGIBLE_CLIENT_SUPPORT_THREE_FOUR,
      screenName: 'csb+_3_4_new_clients',
    });

    listItems.push({
      label: tt('clientAchievedSupportTier2', 'CSB+ (5-6 New Clients)'),
      value: fiveToSixCSBPClientCount,
      testID: MetricsSection.metricQualifiedForCSBP_Five_Six,
      recordsName: REPORT_ELIGIBLE_CLIENT_SUPPORT_FIVE_SIX,
      screenName: 'csb+_5_6_new_clients',
    });

    listItems.push({
      label: tt('clientAchievedSupportTier2', 'CSB+ (7-9 New Clients)'),
      value: sevenToNineCSBPClientCount,
      testID: MetricsSection.metricQualifiedForCSBP_Seven_Nine,
      recordsName: REPORT_ELIGIBLE_CLIENT_SUPPORT_SEVEN_NINE,
      screenName: 'csb+_7_9_new_clients',
    });
  }
  if (!NewCoachesAquiringClients) {
    listItems.push({
      label: tt('coachAccelerator', 'Eligible for Accelerator Bonus'),
      value: eligibleForAccelBonusCount,
      recordsName: REPORT_ELIGIBLE_ACCELERATOR_BONUS,
      testID: MetricsSection.metricEligibleForAB,
    });
  }
  if (NewCoachesAquiringClients) {
    if (showCSBPlus) {
      listItems.push({
        label: tt('clientSupport', 'Earned CSB+ (Last Period)'),
        value: earnedClientSupportBonusPlusCount,
        recordsName: REPORT_EARNED_CLIENT_SUPPORT_BONUS_PLUS,
        testID: MetricsSection.metricEarnedClientSupportBonusPlus,
      });
    }
    listItems.push({
      label: tt('coachAccelerator', 'Earned CAB (Last Period)'),
      value: earnedAccelBonusCount,
      testID: MetricsSection.metricEarnedCoachAcceleratorBonus,
      recordsName: REPORT_EARNED_ACCELERATOR_BONUS,
    });
    listItems.push({
      label: tt('coachAccelerator', 'Eligible for CAB'),
      value: eligibleForAccelBonusCount,
      recordsName: REPORT_ELIGIBLE_ACCELERATOR_BONUS,
      testID: MetricsSection.metricEligibleForCAB,
    });

    listItems.push({
      label: tt('rankUp', 'Rank Up (Last Period)'),
      value: rankUp,
      recordsName: REPORT_RANK_UP,
      testID: MetricsSection.metricRankUp,
    });
  }
  if (FEATURE_FLAGS.showCabBonus) {
    listItems.push({
      label: tt('acquisitionBonus', 'Earned Client Acquisition Bonus'),
      value: clientAcquisitionBonus,
      recordsName: REPORT_EARNED_CAB,
      testID: MetricsSection.metricEarnedClientAcquisitionBonus,
    });
  }
  if (showEligibleQSB) {
    listItems.push({
      label: tt('quickStart', 'Eligible for Quick Start Bonus'),
      value: quickStartBonus,
      recordsName: REPORT_ELIGIBLE_FOR_QSB,
      testID: MetricsSection.metricEligibleForQSB,
    });
  }

  const onInfoPress = () =>
    onShowInfoPopover({
      heading: tt('info.heading', 'Coaches Acquiring Clients'),
      body: tt(
        'info.body',
        'There are some new Coaches in your organization that are off to a great start! Why not reach out and see what they might need to earn their first bonus or additional bonuses.',
      ),
    });

  const onItemPress = ({recordsName, value, screenName}: any) => {
    onShowReport({
      recordsName,
      loadingData: {
        total: value,
        buttonType: 'text',
      },
      screenName,
    });
  };

  return {tt, onItemPress, onInfoPress, listItems, ts};
};
